import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-root',
  standalone: true, // ✅ mark as standalone root component
  imports: [RouterOutlet, NgbModule],
  templateUrl: './app.html',
  styleUrls: ['./app.scss'], // ✅ fixed (was styleUrl)
})
export class App {
  protected readonly title = signal('front-end');
}
